export default __webpack_public_path__ + "static/media/blog-driveway-pattern-002.8b504b14.jpg";